export default __webpack_public_path__ + "static/media/key-horizontal.495a95ae.svg";